export class VersionChecker {
  public static getMaxVersion(versions: string[]): string {
    const sorted = (versions || []).sort(VersionChecker.compareVersions).reverse()
    return sorted.length > 0 ? sorted[0] : null
  }

  private static indexOrEnd(str: string, q: string): number {
    return str.indexOf(q) === -1 ? str.length : str.indexOf(q)
  }

  private static split(str: string): string[] {
    const replacedString = str.replace(/^v/, "").replace(/\+.*$/, "")
    const patchIndex = VersionChecker.indexOrEnd(replacedString, "-")
    const arr = replacedString.substring(0, patchIndex).split(".")
    arr.push(replacedString.substring(patchIndex + 1))
    return arr
  }

  private static tryParse(v: string): any {
    return isNaN(Number(v)) ? v : Number(v)
  }

  private static compareVersions(v1: string, v2: string): number {
    const s1 = VersionChecker.split(v1)
    const s2 = VersionChecker.split(v2)

    for (let i = 0; i < Math.max(s1.length - 1, s2.length - 1); i++) {
      const n1 = parseInt(s1[i] || "0", 10)
      const n2 = parseInt(s2[i] || "0", 10)

      if (n1 > n2) {
        return 1
      }
      if (n2 > n1) {
        return -1
      }
    }

    const sp1 = s1[s1.length - 1]
    const sp2 = s2[s2.length - 1]

    if (sp1 && sp2) {
      const p1 = sp1.split(".").map(this.tryParse)
      const p2 = sp2.split(".").map(this.tryParse)

      for (let i = 0; i < Math.max(p1.length, p2.length); i++) {
        if (p1[i] === undefined || typeof p2[i] === "string" && typeof p1[i] === "number") {
          return -1
        }
        if (p2[i] === undefined || typeof p1[i] === "string" && typeof p2[i] === "number") {
          return 1
        }

        if (p1[i] > p2[i]) {
          return 1
        }
        if (p2[i] > p1[i]) {
          return -1
        }
      }
    } else if (sp1 || sp2) {
      return sp1 ? -1 : 1
    }

    return 0
  }
}
